import { useHistory, useLocation } from "react-router-dom";
import { useInvoice } from "./use-invoice";

export function useInvoiceDrawer() {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const invoiceId = queryParams.get("open_details");
  const isPayable = Boolean(queryParams.get("payable"));
  const isPaying = Boolean(queryParams.get("paying"));

  const { data: invoice, ...rest } = useInvoice({
    invoiceId,
    enabled: !!invoiceId,
  });

  const handleOpen = (id, isPayable = false, isPaying = false) => {
    if (queryParams.has("open_details")) {
      queryParams.delete("open_details");
    }

    queryParams.set("open_details", id);
    if (isPayable) {
      queryParams.set("payable", isPayable);

      if (isPaying) {
        queryParams.set("paying", isPaying);
      }
    }

    history.push({
      search: queryParams.toString(),
    });
  };

  const handleClose = () => {
    if (queryParams.has("open_details")) {
      queryParams.delete("open_details");

      if (queryParams.has("payable")) {
        queryParams.delete("payable");
      }

      if (queryParams.has("paying")) {
        queryParams.delete("paying");
      }

      history.replace({
        search: queryParams.toString(),
      });
    }
  };

  const togglePay = () => {
    if (queryParams.has("payable")) {
      if (queryParams.has("paying")) {
        queryParams.delete("paying");
      } else {
        queryParams.set("paying", true);
      }
    }

    history.replace({
      search: queryParams.toString(),
    });
  };

  return {
    open: queryParams.has("open_details"),
    drawerData: invoice,
    handleClose,
    handleOpen,
    isPayable,
    isPaying,
    togglePay,
    ...rest,
  };
}
